import { useRef, useEffect } from "react";
import { Box } from "@mui/material";

import { dec, dataURLtoFile, drawBox } from "./utils";

export default function ServingExampleAppMOT(props) {
  let backend_url = process.env.REACT_APP_BACKEND_URL;

  const imgRef = useRef("img");

  const inference = async (img) => {
    let data = new FormData();
    data.append("image", img);
    props.onChangeIsInferencing(true);
    const t = Date.now();
    const res = await fetch(`${backend_url}`, {
      method: "POST",
      headers: {
        Accept: "application/json",
      },
      body: data,
    })
      .catch((err) => {
        props.onChangeMsg(`${err}`);
      })
      .finally(() => {
        props.onChangeIsInferencing(false);
      });
    let result = await res.json();
    let arr = dec(result["payload"]);
    props.onChangeTook(Date.now() - t);
    let cvImage = props.cv.imread("img");
    drawBox(
      props.cv,
      cvImage,
      imgRef.current.height,
      imgRef.current.width,
      imgRef.current.naturalHeight,
      imgRef.current.naturalWidth,
      arr,
      result["labels"],
    );
    props.cv.imshow("canvas", cvImage);
    cvImage.delete();
  };

  useEffect(() => {
    if (!props.imgFile) {
      return;
    }
    inference(props.imgFile);
  }, [props.imgFile]);

  return (
    <>
      <Box sx={{ flex: 1 }} style={{ paddingTop: "10px" }} hidden>
        {props.img && (
          <img
            id="img"
            alt="Original input"
            src={props.img}
            ref={imgRef}
            style={{ width: "100%", objectFit: "contain" }}
          />
        )}
      </Box>
      <Box sx={{ flex: 1 }} style={{ paddingTop: "10px" }}>
        <canvas id="canvas" style={{ width: "100%", objectFit: "contain" }} />
      </Box>
    </>
  );
}
